import React from 'react';
import Title from '../Title/Title';
import TextField from '../TextField/TextField';
import Icon from '../Icon/Icon';

import './button.css';
import { COLOURS } from '../../../utils/consts';

interface ButtonProps {
    type?: 'button' | 'submit' | 'reset';
    text: string;
    variant?:
        | 'green'
        | 'red'
        | 'transparent'
        | 'transparent-red'
        | 'transparent-green'
        | 'success'
        | 'warning'
        | 'retro'
        | 'white'
        | 'border';
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    disabled?: boolean;
    onClick?: (event: any) => void;
    iconName?: string;
    textSize?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
    className?: string;
}

const Button: React.FC<ButtonProps> = ({
    text,
    type = 'button',
    variant,
    size,
    disabled = false,
    onClick,
    iconName,
    textSize = 's',
    className = '',
}) => {
    return (
        <button
            className={`btn ${variant || ''} ${size || ''} ${
                iconName ? 'icon' : ''
            } ${className}`}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {iconName && (
                <Icon
                    name={iconName}
                    size="22px"
                    cursor="pointer"
                    title="Edit event"
                    color={
                        variant === 'transparent-red'
                            ? COLOURS.LIGHT_RED
                            : undefined
                    }
                />
            )}
            {variant === 'retro' ? (
                <TextField size={textSize}>{text}</TextField>
            ) : (
                <Title text={text} size={textSize} />
            )}
        </button>
    );
};

export default Button;
